/* eslint-disable react/prop-types */
import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import jobDetailsPageStyle from "assets/jss/material-kit-pro-react/views/jobDetailsPageStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import PreloaderComponent from "../../../components/PreloaderComponent/PreloaderComponent";

import "assets/css/style.css";
import { jobActions, userActions } from "../../../actions";
import { orderActions } from "../../../actions/order.actions";
import { paymentActions } from "../../../actions/payment.actions";
import Priority from "@material-ui/core/SvgIcon/SvgIcon";
import SnackbarContent from "../../../components/Snackbar/SnackbarContent";

class ViewJobPostTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      servicesString: "",
      percent: 10,
      preloader: false,
      payPalError: false,
      payPalErrorMessage: ''
    };
  }

  componentDidMount() {
    let tempString = "";
    if (this.props.lawnMoving) {
      tempString = tempString.concat(" Lawn Mowing, ");
    }
    if (this.props.maintainingHerbaceousBorders) {
      tempString = tempString.concat(" Maintaining herbaceous borders, ");
    }
    if (this.props.gardenCoaching) {
      tempString = tempString.concat(" Garden Coaching, ");
    }
    if (this.props.gardenClearance) {
      tempString = tempString.concat(" Garden Clearance, ");
    }
    if (this.props.hedgeTrimming) {
      tempString = tempString.concat(" Hedge Trimming, ");
    }
    if (this.props.pruning) {
      tempString = tempString.concat(" Pruning, ");
    }
    // if (this.props.vegetableGardening) {
    //   tempString = tempString.concat(" Vegetable gardening, ");
    // }
    // if (this.props.hedgeCutting) {
    //   tempString = tempString.concat(" Hedge cutting - below 6ft, ");
    // }
    tempString = tempString.substr(0, tempString.length - 2);
    this.setState({ servicesString: tempString });
  }

  payJob() {
    this.setState({ preloader: true });
    let quantity = 1;

    let create_order_json = {
      user: this.props.user,
      job: this.props.job,
      price: this.props.job.total * quantity,
      percent: this.state.percent,
      total:
          this.props.job.total + (this.props.job.total * this.state.percent) / 100
    };

    this.props.createOrder(create_order_json).then(
        res => {
          let create_payment_json = {
            name: this.props.job.jobName,
            price: this.props.job.total,
            quantity: quantity,
            total: this.props.job.total * quantity,
            order: res.order
          };

          this.props.createJobPayment(create_payment_json).then(
              res => {
                window.location.href = res.payment.links[1].href;
              },
              err => {
                this.setState({ preloader: false, payPalError: true, payPalErrorMessage: err === "This job has already been paid" ? err : "" });
              }
          );
        },
        err => {
          console.log("55", err);
        }
    );
  }

  closeAlerts = () => {
    this.setState({payPalError: false, payPalErrorMessage: ""});
  };

  render() {
    const {classes} = this.props;
    return (<div>
      {this.state.payPalError ? (
          <div>
            <SnackbarContent
                message={
                  <span>
                      {this.state.payPalErrorMessage === "" ? "Paypal connection error. Please try again later." : this.state.payPalErrorMessage}
                    </span>
                }
                close
                color="danger"
                icon={Priority}
                closeAlert={this.closeAlerts}
            />
          </div>
      ) : null}
      <GridItem
          xs={12}
          sm={12}
          md={7}
          className={classes.alignCenter + " card1"}
      >
        <Card className={"cart-jobs"}>
          <CardBody>
            <h3 className={classes.cardTitle + " " + classes.titleAlignLeft}>
              <p className={"proposals-card-title"}>Job details</p>
            </h3>
            <div className={"proposals-card-msg"}/>

            {this.props.jobDescription && (
                <GridItem xs={12} sm={12} md={12}>
                  <p className={"v-j-variable"}>
                    Job Description:
                    <span className={"v-j-variable-text"}>
                    {" " + this.props.jobDescription}
                  </span>
                  </p>
                </GridItem>
            )}
            {this.state.servicesString !== "" && (
                <GridItem xs={12} sm={12} md={12}>
                  <div>
                    <p className={"v-j-variable"}>
                      Selected service types:
                      <span className={"v-j-variable-text"}>
                      {this.state.servicesString}
                    </span>
                    </p>
                  </div>
                </GridItem>
            )}
              {this.props.lawnMoving && (
                <GridItem xs={12} sm={12} md={12}>
                  <div>
                    {this.props.lawnSize && (
                      <p className={"v-j-variable"}>
                        Lawn Size:
                        <span className={"v-j-variable-text"}>
                          {" " + this.props.lawnSize + " sqm"}
                        </span>
                      </p>
                    )}
                    {this.props.maintenanceFrequency && (
                      <p className={"v-j-variable"}>
                        Lawn Maintenance Frequency:
                        <span className={"v-j-variable-text"}>
                          {" " + this.props.maintenanceFrequency}
                        </span>
                      </p>
                    )}
                  </div>
                </GridItem>
              )}
              {this.props.hours && (
                <GridItem xs={12} sm={12} md={12}>
                  <p className={"v-j-variable"}>
                    Hours:
                    <span className={"v-j-variable-text"}>
                      {" " + this.props.hours + " h"}
                    </span>
                  </p>
                </GridItem>
              )}
              {this.props.bags > 0 && (
                <GridItem xs={12} sm={12} md={12}>
                  <p className={"v-j-variable"}>
                    Bags:
                    <span className={"v-j-variable-text"}>
                      {" " + this.props.bags}
                    </span>
                  </p>
                </GridItem>
              )}
              {this.props.dateTime && (
                <GridItem xs={12} sm={12} md={12}>
                  <p className={"v-j-variable"}>
                    Job date and time:
                    <span className={"v-j-variable-text"}>
                      {this.props.dateTimeEnd && this.props.dateTimeEnd !== ""
                        ? " " +
                          this.props.dateTime +
                          " - " +
                          this.props.dateTimeEnd
                        : " " + this.props.dateTime}
                    </span>
                  </p>
                </GridItem>
              )}
              {this.props.city && (
                <GridItem xs={12} sm={12} md={12}>
                  <p className={"v-j-variable"}>
                    Job city:
                    <span className={"v-j-variable-text"}>
                    {" " + this.props.city}
                  </span>
                  </p>
                </GridItem>
            )}
            {this.props.zipCode && (
                <GridItem xs={12} sm={12} md={12}>
                  <p className={"v-j-variable"}>
                    Job postcode:
                    <span className={"v-j-variable-text"}>
                    {" " + this.props.zipCode}
                  </span>
                  </p>
                </GridItem>
            )}
            {this.props.address && (
                <GridItem xs={12} sm={12} md={12}>
                  <p className={"v-j-variable"}>
                    Job address:
                    <span className={"v-j-variable-text"}>
                    {" " + this.props.address}
                  </span>
                  </p>
                </GridItem>
            )}
            <GridItem xs={12} sm={12} md={12}>
              <p className={"v-j-variable"}>
                Price:
                <span className={"v-j-variable-text"}>
                £{this.props.user.account_type === 1 ?( this.props.total + this.props.total * this.state.percent / 100).toFixed(2) : (this.props.total).toFixed(2)} 
                </span>
              </p>
            </GridItem>
            {this.props.orderPhone && (
                <GridItem xs={12} sm={12} md={12}>
                  <p className={"v-j-variable"}>
                    Contact phone:
                    <span className={"v-j-variable-text"}>
                    {" " + this.props.orderPhone}
                  </span>
                  </p>
                </GridItem>
            )}
            {this.props.orderBestTimeToCall && (
                <GridItem xs={12} sm={12} md={12}>
                  <p className={"v-j-variable"}>
                    Best Time to Call:
                    <span className={"v-j-variable-text"}>
                    {" " + this.props.orderBestTimeToCall}
                  </span>
                  </p>
                </GridItem>
            )}
            {this.props.jobPayment !== 'execute' ? (
                <><button className="paypal-button" onClick={e => this.payJob()}>
                  <span className="paypal-button-title"/>
                  <span className="paypal-logo">
                    <img src="data:image/svg+xml;base64,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" alt="PP" className="paypal-logo paypal-logo-pp paypal-logo-color-blue"></img>
                    <i className={"paypal-logo-first"}>Pay</i>
                    <i className={"paypal-logo-last"}>Pal</i>
                  </span>
                </button>
                <p className="paypal-powerd-by">
                <i className={"paypal-logo-first"}>Powered by </i>
                <span className="paypal-logo-mini">
                  <i className={"paypal-logo-first"}>Pay</i>
                  <i className={"paypal-logo-last"}>Pal</i>
                </span>
                </p></>
            ) : null}
          </CardBody>
        </Card>
      </GridItem>
      {this.state.preloader && <PreloaderComponent/>}
    </div>);
  }
}

export default connect(
  store => {
    return {
      user: store.users.user
    };
  },
  {
    createOrder: orderActions.createOrder,
    createJobPayment: paymentActions.createJobPayment
  }
)(withStyles(jobDetailsPageStyle)(ViewJobPostTab));
